export const ProjectStatus = {
  Private: 'PRIVATE',
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
} as const;

export type ProjectStatus = (typeof ProjectStatus)[keyof typeof ProjectStatus];

export const ProjectStateUpdateEvent = {
  Activate: 'ACTIVATE',
  Archive: 'ARCHIVE',
  Restore: 'RESTORE',
} as const;

export type ProjectStateUpdateEvent = (typeof ProjectStateUpdateEvent)[keyof typeof ProjectStateUpdateEvent];
